query GetActivityTypeDefaults {
    activityTypeDefaults {
        defaultType
        activityType {
            id
        }
    }
}
